var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.645 -0.645 18 18",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.29
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 1.6,
    width: 5.6,
    height: 5.6,
    rx: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 1.6,
    width: 5.6,
    height: 5.6,
    rx: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 9.5,
    width: 5.6,
    height: 5.6,
    rx: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 9.5,
    width: 5.6,
    height: 5.6,
    rx: 1.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApps);
export default __webpack_public_path__ + "static/media/apps.c7a4b5e24be9db975d178be463b57d1c.svg";
export { ForwardRef as ReactComponent };